import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 px-4 bg-red-50 border-y border-red-200" data-id="element-161">
      <div className="max-w-3xl mx-auto text-center" data-id="element-162">
        <h2 className="text-2xl md:text-3xl font-bold text-[#3C1518] mb-4" data-id="element-163">
          ¡Atención! Esta oferta especial desaparece en:
        </h2>
        <div className="text-4xl md:text-6xl font-black text-[#DC2626] mb-6 drop-shadow-lg" data-id="element-164">
          <CountdownTimer data-id="element-165" />
        </div>
        <p className="text-lg text-[#5C2D0E]" data-id="element-166">
          No dejes pasar esta oportunidad única de llevarte el recetario
          principal + todos los bonos gratis.
        </p>
      </div>
    </section>;
}